import { useParams } from 'react-router-dom'
import { Link } from 'react-router-dom'
import { useInventorySystemProfileToVenue } from '../../hooks/useInventorySystemProfileToVenue'
import { useInventorySystemProfile } from '../../hooks/useInventorySystemProfile'
import { useVenue } from '../../hooks/useVenue'
import { useTenantGroups } from '../../hooks/useTenantGroups'
import { DetailEntityPage } from '../DetailEntityPage/DetailEntityPage'
import { Badge } from '../../components/Badge/Badge'
import type { DetailFieldDef } from '../../types'

export function InventorySystemProfileToVenueDetailPage() {
  const { ispId, venueId } = useParams<{ ispId: string; venueId: string }>()
  const {
    mapping,
    isLoading: mappingLoading,
    error: mappingError,
  } = useInventorySystemProfileToVenue(ispId ?? '', venueId ?? '')
  const { profile, isLoading: profileLoading } = useInventorySystemProfile(
    ispId ?? ''
  )
  const { venue, isLoading: venueLoading } = useVenue(venueId ?? '')
  const { tenantGroups, isLoading: groupsLoading } = useTenantGroups()

  const isLoading =
    mappingLoading || profileLoading || venueLoading || groupsLoading

  const tenantGroupCode = tenantGroups.find(
    (g) => g.id === mapping?.tenantGroupId
  )?.code

  const fields: DetailFieldDef[] = mapping
    ? [
        {
          label: 'ISP Profile',
          value: (
            <Badge color="grey">
              {profile?.code ?? mapping.inventorySystemProfileId}
            </Badge>
          ),
        },
        {
          label: 'Venue',
          value: <Badge color="grey">{venue?.name ?? mapping.venueId}</Badge>,
        },
        {
          label: 'Tenant Group',
          value: (
            <Badge color="grey">
              {tenantGroupCode ?? mapping.tenantGroupId}
            </Badge>
          ),
        },
      ]
    : []

  return (
    <DetailEntityPage
      title="ISP to Venue Mapping"
      loadingLabel="ISP to venue mapping"
      fields={fields}
      isLoading={isLoading}
      error={mappingError}
      actions={
        ispId &&
        venueId && (
          <Link
            to={`/isp-to-venues/${ispId}/${venueId}/delete`}
            className="btn btn-outline-danger btn-sm"
          >
            Delete
          </Link>
        )
      }
    />
  )
}
